'use client';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @primitive ToggleGroup
 * ROLE: group | ARIA: aria-pressed on each item; group needs aria-label
 * KEYBOARD: ArrowLeft/ArrowRight navigate items (roving tabindex); Space/Enter toggle
 * FOCUS: one tab stop (roving tabindex via Radix); first/selected item gets focus
 * LIVE-REGION: none
 * PRM: transition instant
 * FORCED-COLORS: active item border = Highlight
 * RTL: arrow-key direction-aware via Radix
 * RSC: CLIENT
 * WAI-APG: https://www.w3.org/WAI/ARIA/apg/patterns/toolbar/
 * SUBSTRATE: @radix-ui/react-toggle-group
 */
import * as RadixToggleGroup from '@radix-ui/react-toggle-group';
import styles from './ToggleGroup.module.css';
export function ToggleGroup(props) {
    if (props.type === 'single') {
        const { type: _t, value, onValueChange, children, ...ariaProps } = props;
        return (_jsx(RadixToggleGroup.Root, { type: "single", value: value, onValueChange: onValueChange, className: styles.root, ...ariaProps, children: children }));
    }
    const { type: _t, value, onValueChange, children, ...ariaProps } = props;
    return (_jsx(RadixToggleGroup.Root, { type: "multiple", value: value, onValueChange: onValueChange, className: styles.root, ...ariaProps, children: children }));
}
export function ToggleGroupItem({ value, disabled = false, children, ...ariaProps }) {
    return (_jsx(RadixToggleGroup.Item, { value: value, disabled: disabled, className: styles.item, ...ariaProps, children: children }));
}
//# sourceMappingURL=ToggleGroup.js.map